import { UpdateOfficeAdapters } from '../adapters';
import { addAddress } from '../clients/AddAddress';
import { updateOfficeInfo } from '../clients/UpdateOfficeInfo';
import { updateUserEducation } from '../clients/UpdateUserEducation';
import { UpdateOfficeApiError } from '../errors';
import type { IUpdateOfficeRequest } from '../types/UpdateOffice';

const updateOffice = async (input: IUpdateOfficeRequest): Promise<void> => {
  try {
    await updateOfficeInfo(UpdateOfficeAdapters.toUpdateOfficeInfoPayload(input));
    if (input.placeId) {
      try {
        await addAddress(UpdateOfficeAdapters.toAddAddressPayload(input.placeId));
      } catch (addressError) {
        // Address failures (e.g. BE enforces same-state rule) should paint the
        // address field — tag the typed error so the form can setError on it.
        const typed = UpdateOfficeApiError.fromAxiosError(addressError, 'officeAddress');
        throw typed ?? addressError;
      }
    }
    await updateUserEducation(UpdateOfficeAdapters.toUpdateUserEducationPayload(input));
  } catch (error) {
    if (error instanceof UpdateOfficeApiError) {
      throw error;
    }
    const typedError = UpdateOfficeApiError.fromAxiosError(error);
    throw typedError ?? error;
  }
};

export const UpdateOfficeService = { updateOffice };
